module.exports = __webpack_public_path__ + "static/media/wide.d3f2bea5.jpg";